import { z } from "zod";
import { PRODUCTION_STATE_VALUES } from "../../constants/production-state.js";
export const productionTransitionSchema = z.object({
    to: z.enum(PRODUCTION_STATE_VALUES),
});
export const AdminProductionProgressSchema = z.object({
    productionState: z.enum(PRODUCTION_STATE_VALUES),
    totalJobs: z.number().int().nonnegative(),
    pendingJobs: z.number().int().nonnegative(),
    processingJobs: z.number().int().nonnegative(),
    completedJobs: z.number().int().nonnegative(),
    failedJobs: z.number().int().nonnegative(),
    costUsd: z.number().nonnegative(),
});
